import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function BonusSection() {
  return <section className="py-20 bg-white px-4 relative" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-coral-400 to-peach-400 rounded-[2.5rem] p-1 shadow-warm-xl" data-id="element-3">
          <div className="bg-cream-50 rounded-[2.3rem] p-8 md:p-14 text-center relative overflow-hidden" data-id="element-4">
            {/* Background decoration */}
            <div className="absolute top-0 right-0 w-80 h-80 bg-peach-100 rounded-full -translate-y-1/2 translate-x-1/2 opacity-60 blur-2xl" data-id="element-5"></div>
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-coral-50 rounded-full translate-y-1/2 -translate-x-1/3 opacity-60 blur-2xl" data-id="element-6"></div>

            <div className="relative z-10" data-id="element-7">
              

              <h2 className="text-3xl md:text-4xl font-bold text-warm-gray mb-4" data-id="element-8">
                🎁 BONO INCLUIDO – Totalmente GRATIS hoy
              </h2>

              <div className="my-10 p-8 bg-white rounded-3xl border border-peach-100 flex flex-col md:flex-row items-center gap-8 shadow-warm-sm hover:shadow-warm-md transition-shadow duration-300" data-id="element-9">
                <div className="flex-shrink-0 w-24 h-24 rounded-2xl overflow-hidden border border-green-100" data-id="element-10">
                  <img src="https://cdn.magicpatterns.com/uploads/uTPx9uhjMoZdisy8Nabc7V/Gemini_Generated_Image_3bh6sz3bh6sz3bh6.png" alt="Plantilla de Gastos" className="w-full h-full object-cover" data-id="element-11" />
                </div>
                <div className="text-left flex-1" data-id="element-12">
                  <h3 className="text-2xl font-bold text-warm-gray mb-2" data-id="element-13">
                    Plantilla de Gastos Automatizada
                  </h3>
                  <p className="text-warm-800 mb-4 text-lg" data-id="element-14">
                    Descubre por qué te cuesta ahorrar, identifica tus "gastos
                    hormiga" y reprograma tu mente para tomar decisiones
                    financieras sin miedo.
                  </p>
                  <div className="inline-block bg-coral-50 px-4 py-2 rounded-lg border border-coral-100" data-id="element-15">
                    <p className="text-sm font-bold text-coral-600" data-id="element-16">
                      Valor real:{' '}
                      <span className="line-through text-coral-300 mx-1" data-id="element-17">
                        $14.99
                      </span>{' '}
                      ¡GRATIS con tu compra!
                    </p>
                  </div>
                </div>
              </div>

              <p className="text-xl font-medium text-terracotta-700" data-id="element-18">
                Resultados reales comienzan en tu mentalidad y se reflejan en
                tus números.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}